module.exports = __webpack_public_path__ + "static/media/error.48260429.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error.svg
// module id = 1101
// module chunks = 1